
import Component from "vue-class-component";
import Vue from "vue";
import { SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { EditBillToCommodityModel } from "@/models/ui/editBillToCommodity";
import { formatDateWithTime } from "@/utils";
import notifications from "../../lib/notifications";
import { BillToCommodityCodeResource } from "../../models/api/system/billToCommodities";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ImportTrucks extends Vue {
  commodities: any = null;
  billTo: string = null;
  commodityCode: string = null;
  loading: boolean = false;
  records: BillToCommodityCodeResource[] = null;
  editId: number = null;
  editModel: EditBillToCommodityModel = null;

  async created() {
    await this.loadCommodities();
  }
  async loadCommodities() {
    try {
      const results = await systemModule.searchCommoditiesByCode({ code: null, billTo: null });
      this.$data.commodities = results.map(x => ({ label: x.code, value: x.code }));
    } catch (ex) {
      console.error("Failed to load commodities", ex);
    }
  }

  async loadData() {
    this.loading = true;
    try {
      this.records = await systemModule.getBillToCommodityCodes({
        billTo: this.billTo,
        code: this.commodityCode
      });
    } catch (ex) {
      notifications.error("Search Failed", "Failed to load records", ex);
    }
    this.loading = false;
  }

  format(dateToFormat) {
    return formatDateWithTime(dateToFormat);
  }

  goBack() {
    this.$router.back();
  }

  async filter() {
    await this.loadData();
  }

  editRecord(record: BillToCommodityCodeResource = null) {
    const model = new EditBillToCommodityModel();

    if (record) {
      model.id = record.id;
      model.commodityCode = record.commodityCode;
      model.billTo = record.billTo;
    }

    this.editModel = model;
  }

  closeEditModal() {
    this.editModel.visible = false;
    this.editModel = null;
  }

  async saveRecord() {
    try {
      this.editModel.saving = true;
      if (this.editModel.isNew) {
        await systemModule.createBillToCommodityCode(this.editModel.toCreateRequest());
      } else {
        await systemModule.updateBillToCommodityCode(this.editModel.toUpdateRequest());
      }
      await this.loadData();
      this.editModel.visible = false;
      this.editModel = null;
      notifications.success("Save Success", "Record successfully saved");
    } catch (ex) {
      this.editModel.saving = false;
      notifications.error("Save Failed", "Failed to save record", ex);
    }
  }

  async deleteRecord(record: BillToCommodityCodeResource) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to delete this record? This action cannot be undone."
    );
    if (confirmed) {
      try {
        await systemModule.deleteBillToCommodityCode(record.id);
        await this.loadData();
        notifications.success("Delete Bill To Commodity", "Record successfully deleted.");
      } catch (ex) {
        notifications.error("Delete Bill To Commodity", "Failed to delete record", ex);
      }
    }
  }

  get canFilter() {
    return this.commodityCode || this.billTo;
  }
}
